import React from "react";
import "./Ourblogspages.css";
import Ourblogspagesheading from "./Ourblogspagesheading";
import Navbar from "../../components/Navbar/Navbar";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Footer from "../../components/Footer/Footer";
import Ourblogspagebanner from "./Ourblogspagebanner";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import { useEffect } from "react";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import { Helmet } from "react-helmet-async";

function Ourblogspages() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
              <title>Our Blogs Page | Dwebbox</title>
              <link
                rel="canonical"
                href="https://dwebbox.com/BlogsPage.html"
              />
            </Helmet>
      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Ourblogspagesheading />
      <Ourblogspagebanner />
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Ourblogspages;
